/**
 * card-photo.js -- small product photos fill their image area (H3/G5, Auftraggeber 06.10.2026).
 *
 * Cards, finder results, lists and thumbnails give every photo the same image area per building
 * block (CSS: object-fit: contain inside a fixed box with a small inner margin). Cut-out photos often
 * carry wide transparent margins, so the product "floats" small in the frame. This script measures
 * the visible (non-transparent) area of each photo with the shared assets/photo-fit.js (a 160-px copy,
 * read-only) and scales the photo so that the product fills about 94 % of its box, centred, never
 * cropped. Photos without transparency (4:3 photos with background) stay as they are (contain).
 *
 * No markup changes needed: the building blocks are listed in SELECTOR. Images added later (finder,
 * wishlist rows, cart drawer, cross-sell) are picked up by a MutationObserver; boxes that change
 * size are re-fitted (ResizeObserver). Hover zooms on cards use the CSS "scale" property, which
 * combines with the transform set here. Loaded on every page from sections/header.liquid.
 */
(function () {
  if (window.CryonosCardPhoto) return;
  var SELECTOR = [
    '.buy-card__img img', '.buy-mini__img img', '.buy-mcc__img img', '.wl__img img',
    '.buy-cl__img img', '.cart-drawer__item-media img', '.rg-table__name img',
    '.pfn-ph img', '.pfn-tph img', '.pfn-aimg img', '.pfn-setimg img', '.pfn-ex .img img',
    '.rg-explorer__photo img', '.rg-tab__img img', '.rg-fit__photo img', '.rg-mx thead th img',
    '.csx-card__fig img', '.rg-sp-card__img img'
  ].join(',');
  var OPTS = { w: 0.94, h: 0.94, base: 0.97, max: 4 };

  var style = document.createElement('style');
  style.textContent = 'img.cph{transform:translate(var(--fx,0px),var(--fy,0px)) scale(var(--fs,1));transform-origin:50% 50%}';
  document.head.appendChild(style);

  function small(src) {
    if (!src) return null;
    try {
      var u = new URL(src, location.href);
      if (!/\/cdn\/shop\/|cdn\.shopify\.com/.test(u.href)) return null;
      u.searchParams.set('width', '160');
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.href;
    } catch (e) { return null; }
  }

  function fit(img) {
    var PF = window.CryonosPhotoFit;
    if (!PF) return;
    var url = small(img.getAttribute('src'));
    if (!url) return;
    PF.probe(url).then(function (bb) {
      var W = img.clientWidth, H = img.clientHeight;
      if (!W || !H) return;
      var v = PF.fitValues(W, H, bb, OPTS);
      img.classList.add('cph');
      img.classList.toggle('is-cph-cut', !!v);
      PF.apply(img, v, 1);
    });
  }

  var ro = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) { fit(e.target); });
  }) : null;

  function scan(root) {
    if (!window.CryonosPhotoFit) return;
    var list = (root || document).querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(list, function (img) {
      var src = img.getAttribute('src');
      if (img.__cph === src) return;
      var first = img.__cph === undefined;
      img.__cph = src;
      fit(img);
      if (first && ro) ro.observe(img);
    });
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; scan(document); });
  }

  function start() {
    scan(document);
    if ('MutationObserver' in window) {
      new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    }
  }

  window.CryonosCardPhoto = { scan: scan, selector: SELECTOR };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
